import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '@/core/utils/cn';
export const Input = forwardRef(({ className, error, ...props }, ref) => (_jsx("input", { ref: ref, className: cn('flex h-10 w-full rounded-md border bg-surface px-3 py-2 text-sm placeholder:text-text-tertiary', 'focus-visible:outline-none focus-visible:border-primary', 'disabled:cursor-not-allowed disabled:opacity-60', error ? 'border-danger' : 'border-border', className), ...props })));
Input.displayName = 'Input';
